var React = require("react");
import Tooltip from '../../Tooltip';
import tooltipDescriptions from '../../TooltipDescriptions';
const costMappings = JSON.parse(
  document.getElementById("cost-mappings").getAttribute("data_value")
);

class MicroServicesAccordion extends React.Component {
  constructor() {
    super();
    this.state = {
      open: false,
    };
    this.onClick = this.onClick.bind(this);
    this.contents = this.contents.bind(this);
    this.checkboxClick = this.checkboxClick.bind(this);
    this.renderOption = this.renderOption.bind(this);
  }

  onClick(e) {
    this.props.actions.clickAccordion(this.props.index, e.target.checked);
    this.setState({ open: !this.state.open });
  }

  checkboxClick(inputName, e) {
    this.props.actions.checkInput(
      this.props.index,
      inputName,
      e.target.checked
    );
  }

  renderOption(testId, displayName) {
    return (
      <div>
        <input
          className="user-checkbox big-checkbox"
          id={testId}
          value={testId}
          type="checkbox"
          name={`option-${this.props.index}[]`}
          onClick={(e) => {
            this.checkboxClick(testId, e);
          }}
        />
        <span className="option-label">
          <Tooltip text={tooltipDescriptions[testId] || displayName}>
            {displayName} (${costMappings[testId]})
          </Tooltip>
        </span>
      </div>
    );
  }

  contents() {
    if (this.state.open) {
      return (
        <div className="accordion-contents">
          {this.renderOption('microservices__pcr_bacteria_analysis', 'Bacteria qPCR')}
          {this.renderOption('microservices__pcr_yeast_analysis', 'Yeast qPCR')}
          {this.renderOption('microservices__pasteurization_analysis', 'Pathogen Organisms')}
          {this.renderOption('microservices__plate_analysis', 'Plating (Single Media)')}
          {this.renderOption('microservices__pcr_and_plate_analysis', 'Plating (Comprehensive Media)')}
          {this.renderOption('microservices__spoiler_micro_simple', 'Spoiler Micro (Simple)')}
          {this.renderOption('microservices__spoiler_micro_comprehensive', 'Spoiler Micro (Comprehensive)')}
          {this.renderOption('microservices__pasteurization_validation_simple', 'Pasteurization Validation (Simple)')}
          {this.renderOption('microservices__pasteurization_validation_comprehensive', 'Pasteurization Validation (Comprehensive)')}
          {this.renderOption('microservices__shelf_life_analysis_simple', 'Shelf Life Analysis (Simple)')}
          {this.renderOption('microservices__shelf_life_analysis_comprehensive', 'Shelf Life Analysis (Comprehensive)')}
        </div>
      );
    }
  }

  render() {
    return (
      <div className="accordion chemistry">
        <div onClick={this.onClick}>
          <input
            type="checkbox"
            className="user-checkbox big-checkbox"
            checked={this.state.open}
            readOnly
          />
          <span className="option-label">
            Micro Services{" "}
            <small>
              <i> - (Click/tap to see options)</i>
            </small>
          </span>
        </div>
        {this.contents()}
      </div>
    );
  }
}

export default MicroServicesAccordion;
